<template>
    <div class="sectionpicker" :class="input.extraClass">
        <span class="headline">
            {{ input.label }}
            <HelperBox v-if="input.helper" :text="input.helper"></HelperBox>
        </span>
        <div :class="input.grid" class="inner grid-50w">
            <template v-if="input.sectionPicker">
                <div class="input" type="checkboxlist">
                    <label>
                        <section>
                            <label class="radio" v-for="picker in input.sectionPicker">
                                <input
                                        type="checkbox"
                                        :data-value="picker.label"
                                        :checked="isChecked(formValue, input.value, picker.label)"
                                        v-on:click="checkSetNestedValue(picker.label, input.value, $event)" />
                                <small>{{ picker.label }}</small>
                            </label>
                        </section>
                    </label>
                </div>
            </template>

            <template v-for="(sectionInput, index) in input.forms">
                <template v-if="sectionInput.type == 'section'">                    
                    <Section :input="sectionInput" :formValue="formValue" v-if="isChecked(formValue, input.value, sectionInput.sectionPickerKey)"></Section>
                </template>               
                <template v-else-if="sectionInput.type == 'sectionarraysimple'">                   
                    <SectionArraySimple :input="sectionInput" :formValue="formValue" v-if="isChecked(formValue, input.value, sectionInput.sectionPickerKey)"></SectionArraySimple>       
                </template>        
            </template>
        </div>
    </div>
</template>

<script>        
    import Section from "./Section.vue"    
    //import SectionPicker from "./SectionPicker.vue"
    import HelperBox from "../HelperBox.vue"
    import SectionArraySimple from "./SectionArraySimple.vue" 
    

    export default {
        components: {            
            Section,                    
            SectionArraySimple,
            //SectionPicker,
            HelperBox            
        },
        name: "SectionPicker",
        props: {
            input: {
                type: Object,
                required: true
            },
            formValue: {
                type: Object,
                required: false
            }
        },
        mounted () {

        },
        methods: {
            isChecked (object, field, value) {
                //console.log("checked start");
                var checked = this.getNestedValue(object, field) == value                
                return checked;
                
            },
            checkSetNestedValue (value, key, e) {
                //console.log(key + ":" + value + ":" + e.target.checked);
                if(!e.target.checked)
                    value = "";
                //debugger;
                this.setNestedValue(this.formValue, value, key);

                // Force update when adding new array.. Deep nesting is does not update sometimes
               
                this.$nextTick(() => {
                    this.$forceUpdate();
                });
                
            }
        }
    }
</script>